
let comparisonCurrentSlide = 0;
const comparisonTotalSlides = 3;

function changeComparisonSlide(direction) {
    comparisonCurrentSlide = (comparisonCurrentSlide + direction + comparisonTotalSlides) % comparisonTotalSlides;
    updateComparisonSlider();
}

function goToComparisonSlide(index) {
    comparisonCurrentSlide = index;
    updateComparisonSlider();
}

function updateComparisonSlider() {
    const track = document.getElementById('comparisonSlider');
    if (track) {
        track.style.transform = `translateX(-${comparisonCurrentSlide * 100}%)`;
    }
    
    // Update dots
    const dots = document.querySelectorAll('.mobile-dot');
    dots.forEach((dot, index) => {
        if (index === comparisonCurrentSlide) {
            dot.classList.add('active');
        } else {
            dot.classList.remove('active');
        }
    });
}

// Touch/Swipe support for mobile slider
document.addEventListener('DOMContentLoaded', function() {
    const slider = document.getElementById('comparisonSlider');
    if (slider) {
        let startX = 0;
        let endX = 0;
        
        slider.addEventListener('touchstart', function(e) {
            startX = e.changedTouches[0].screenX;
        }, {passive: true});
        
        slider.addEventListener('touchend', function(e) {
            endX = e.changedTouches[0].screenX;
            handleSwipe();
        }, {passive: true});
        
        function handleSwipe() {
            const diff = startX - endX;
            if (Math.abs(diff) > 50) {
                if (diff > 0) {
                    changeComparisonSlide(1); // Swipe left - next
                } else {
                    changeComparisonSlide(-1); // Swipe right - previous
                }
            }
        }
    }
});
